export interface ICreditCardSource {
  brand:
    | 'Visa'
    | 'MasterCard'
    | 'American Express'
    | 'Diners Club'
    | 'Discover'
    | 'JCB'
    | 'UnionPay'
    | 'Unknown';
  exp_month: number;
  exp_year: number;
  id: string;
  last4: string;
}

export type TBankAccountStatus =
  | 'new'
  | 'validated'
  | 'verified'
  | 'verification_failed'
  | 'errored';

export interface IBankAccountSource {
  account_holder_name: string;
  bank_name: string;
  id: string;
  last4: string;
  status: TBankAccountStatus;
}

export type TSource = ICreditCardSource | IBankAccountSource;

export function isCreditCardSource(source: TSource) {
  if ((source as ICreditCardSource).exp_month) {
    return true;
  }

  return false;
}

export function isBankAccountSource(source: TSource) {
  if ((source as IBankAccountSource).bank_name) {
    return true;
  }

  return false;
}

export const sourceValidation = {
  routing_number: {
    presence: {
      allowEmpty: false,
    },
  },
  account_number: {
    presence: {
      allowEmpty: false,
    },
  },
  account_holder_name: {
    presence: {
      allowEmpty: false,
    },
  },
};
